<template>
  <div class="flex items-center px-4 py-3">
    <div class="w-12 flex items-center mr-1">
      <VImg
        transition="none"
        :width="24"
        :height="24"
        :src="logo"
        alt="Telehealth Logo"
        draggable="false"
      />
    </div>

    <div class="flex gap-1">
      <VBtn
        v-if="!hospitalId && hasTccItRole"
        variant="text"
        :active="route.path === '/admin/hospitals'"
        to="/admin/hospitals"
        class="button-medium text-primary-text p-2"
      >
        {{ t('Hospitals') }}
      </VBtn>

      <VBtn
        v-if="hospitalId && hasTccItRole"
        variant="text"
        :active="route.path === '/admin/hospitals'"
        to="/admin/hospitals"
        class="button-medium text-primary-text p-2"
        prepend-icon="chevron_left"
      >
        {{ t('All Hospitals') }}
      </VBtn>

      <div v-if="hospitalId" class="flex items-center">
        <div class="w-px h-8 bg-[#0000001A]" />

        <div class="flex items-center bg-[#206683] rounded-md px-2 py-1 ml-4 mr-px">
          <span class="typography-subtitle-2 text-white max-w-[300px] truncate">{{
            getHospitalNameById(hospitalId)
          }}</span>
        </div>

        <VIcon class="opacity-25">chevron_right</VIcon>
      </div>

      <VBtn
        variant="text"
        :active="route.path === '/admin/users' || route.path === `/admin/users/${hospitalId}`"
        :to="hospitalId ? `/admin/users/${hospitalId}` : '/admin/users'"
        class="button-medium text-primary-text p-2"
      >
        {{ t('Users') }}
      </VBtn>

      <VBtn
        variant="text"
        :active="route.path === '/admin/patients' || route.path === `/admin/patients/${hospitalId}`"
        :to="hospitalId ? `/admin/patients/${hospitalId}` : '/admin/patients'"
        class="button-medium text-primary-text p-2"
      >
        {{ t('Patients') }}
      </VBtn>

      <VBtn
        v-if="hospitalId"
        variant="text"
        :active="route.path.includes(`/admin/settings/${hospitalId}`)"
        :to="{
          name: routeNames.ADMIN_SETTINGS_ACCOUNT,
          params: { hospitalId }
        }"
        class="button-medium text-primary-text p-2"
      >
        {{ t('Settings') }}
      </VBtn>

      <VBtn
        v-if="hasTccItRole"
        data-testid="routing-tab-button"
        variant="text"
        :active="route.path === '/admin/routing'"
        :to="'/admin/routing'"
        class="button-medium text-primary-text p-2"
      >
        {{ t('Routing') }}
      </VBtn>
    </div>
  </div>

  <v-spacer />

  <div class="flex items-center px-4 py-3">
    <v-menu>
      <template v-slot:activator="{ props }">
        <VBtn variant="text" v-bind="props" class="button-medium text-secondary-text">
          {{ getFullName }}
          <VIcon end>keyboard_arrow_down</VIcon>
        </VBtn>
      </template>

      <v-list class="p-3 mt-2 w-[280px]">
        <!-- <v-list-item to="/admin/settings" class="rounded-lg p-1 !min-h-8 hover:bg-[#E5E5E5]">
          <v-list-item-title class="text-primary-text">{{ t('User Settings') }}</v-list-item-title>
        </v-list-item> -->
        <v-list-item @click="logout" class="rounded-lg p-1 !min-h-8 hover:bg-[#E5E5E5]">
          <v-list-item-title class="text-primary-text">{{ t('Logout') }}</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
  </div>
</template>

<script setup lang="ts">
import { useRoute } from 'vue-router'
import { useUserStore } from '@/stores/user'
import logo from '@/assets/tcclogo.png'
import { AuthenticationService } from '@/services/AuthenticationService'
import { useI18n } from 'vue-i18n'
import { storeToRefs } from 'pinia'
import { watch } from 'vue'
import { routeNames } from '@/router/routeNames'

const route = useRoute()
const userStore = useUserStore()
const { t } = useI18n()

const { hospitalId, hasTccItRole, getFullName, user } = storeToRefs(userStore)

watch(
  () => route.params,
  (newParams) => {
    userStore.setHospitalId(newParams.hospitalId as string)
  }
)

function getHospitalNameById(id: string): string {
  const name = user.value?.hospitals?.find((hospital) => hospital.id === id)?.name
  return name ?? id
}

async function logout() {
  await AuthenticationService.logout()
}
</script>
